import { Navigate, RouteObject } from "react-router";
import { ComponentType, LazyExoticComponent } from "react";
import { LazyImport } from "@/components/basic/lazy-import";

export type LazyComponent = LazyExoticComponent<ComponentType>;

export const buildRoutes = (routes: AppConfigs.RouteConfig[]): RouteObject[] => {
  return routes.map((item) => {
    const { element, middlewares, children, redirect, ...restProps } = item;

    // 要返回的路由对象
    let routeObject: RouteObject = {
      ...restProps,
    } as RouteObject;

    // 递归构建子路由
    if (children) {
      routeObject.children = buildRoutes(children);
    }

    // 异步加载组件
    routeObject.element = <LazyImport lazy={element} />;

    // 重定向处理
    if (redirect) {
      routeObject.element = <Navigate to={redirect} replace />;
    }

    // 中间件处理
    if (middlewares && middlewares.length > 0) {
      // 从后往前遍历中间件，这样中间件的执行顺序就是从前往后
      // 例如：[A, B, C] => A(B(C()))
      for (let i = middlewares.length - 1; i >= 0; i--) {
        const middleware = middlewares[i];
        routeObject = {
          element: <LazyImport lazy={middleware} />,
          children: [routeObject],
        };
      }
    }

    // 返回路由对象
    return routeObject;
  });
};
